import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../NavBar';
import Events from './Events';
import EventsIntro from './EventsIntro';
import Awards from './Awards';
import Exhibitions from './Exhibitions';
import { getEvents } from '../../services/gallery';
import Loading from '../Loading';
import portugalImg from '../../images/events/portugal.jpg';
import monacoImg from '../../images/events/monaco.jpg';
import sardiniaImg from '../../images/events/sardinia.webp';
import Footer from "../Footer";

const competitions = [
  {
    id: 'monaco-energy-boat-challenge',
    name: 'Monaco Energy Boat Challenge',
    month: 'July',
    image: monacoImg,
    url: 'https://www.energyboatchallenge.com',
  },
  {
    id: 'portugal-boat-challenge',
    name: 'Portugal Boat Challenge',
    month: 'September',
    image: portugalImg,
    url: 'https://www.portugalboatchallenge.pt',
  },
  {
    id: 'sardinia-innovative-boat-week',
    name: 'Sardinia Innovative Boat Week',
    month: 'October',
    image: sardiniaImg,
    url: 'https://www.sardiniainnovativeboatweek.it/en',
  },
];

export default function EventsPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }, [location]);

  // Fetch Data
  useEffect(() => {
    const unsub = getEvents((fetchedEvents) => {
      setEvents(fetchedEvents);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white overflow-x-hidden">
        <NavBar activeSection="events" />
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <NavBar />
      
      <EventsIntro />
      
      <section className="relative w-full py-20 md:py-32 px-4 overflow-hidden bg-slate-950">
        <div className="relative z-10 max-w-6xl mx-auto">
          <h2 className="font-custom font-bold text-white md:text-8xl text-5xl text-center mb-12">
            COMPETITIONS
          </h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {competitions.map((comp) => (
              <button
                key={comp.id}
                onClick={() => window.open(comp.url, '_blank')}
                className="group relative overflow-hidden rounded-2xl border border-slate-700 hover:border-mainBlue transition-all duration-300 hover:transform hover:scale-105 aspect-square"
              >
                <img 
                  src={comp.image} 
                  alt={comp.name}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent z-10" />
                <div className="relative z-20 p-6 h-full flex flex-col justify-end text-left">
                  <h3 className="text-white font-bold text-lg mb-1">{comp.name}</h3>
                  <p className="text-gray-400 text-sm">{comp.month}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <div id="awards"><Awards /></div>
      <div id="exhibitions"><Exhibitions /></div>
      <div id="gallery"><Events events={events} /></div>
      <Footer />
    </div>
  );
}